module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }